<template>
  <v-container grid-list-xl class="pa-0">
    <v-layout wrap>
      <v-flex xs12>
        <m-card-list
          two-line
          title="Admin Tenant"
          search
          :items="items"
          :headers="headers"
          refresh
          @refresh="load"
          :page="page"
          footer
          @search="(search)=>{textSearch=search;load()}"
          @change:page="(pg)=>{cp=pg;load()}"
          @add="add"
        >
          <template v-slot:items="{props,item}">
            <tr v-if="$vuetify.breakpoint.smAndUp">
              <td>
                <m-labelicon
                  icon="mdi-account"
                  avatar-color="grey"
                  :avatar-size="40"
                  :icon-size="30"
                >
                  <div>
                    <div class="block subtitle-1">
                      <router-link
                        class="ok"
                        :to="{name:'user.detail', params:{organisasi_id:organisasi_id,user_id:item.user_id}}"
                      >{{pVal(item,'nama')}}</router-link>
                    </div>
                  </div>
                </m-labelicon>
              </td>
              <td>{{pVal(item,'email')}}</td>
              <td>{{pVal(item,'no_hp')}}</td>
              <td>{{pVal(item,'gender')}}</td>
              <td>
                <v-chip outlined :color="$user.statusColor(item.k_status)">{{pVal(item,'status')}}</v-chip>
              </td>
              <!-- <td>
                <m-menu left style="float:right" :items="more_menu" :object="item" />
              </td>-->
            </tr>
            <tr v-else>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[0].text}}</div>
                  <div class="v-data-table__mobile-row__cell">
                    <router-link
                      class="ok"
                      :to="{name:'user.detail', params:{organisasi_id:organisasi_id,user_id:item.user_id}}"
                    >{{pVal(item,'nama')}}</router-link>
                  </div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[1].text}}</div>
                  <div class="v-data-table__mobile-row__cell">{{pVal(item,'email')}}</div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[2].text}}</div>
                  <div class="v-data-table__mobile-row__cell">{{pVal(item,'no_hp')}}</div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[3].text}}</div>
                  <div class="v-data-table__mobile-row__cell">{{pVal(item,'gender')}}</div>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[4].text}}</div>
                  <div class="v-data-table__mobile-row__cell">
                    <v-chip
                      outlined
                      :color="$user.statusColor(item.k_status)"
                    >{{pVal(item,'status')}}</v-chip>
                  </div>
                </div>
              </td>
              <!-- <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__wrapper">
                  <div class="v-data-table__mobile-row__header">{{headers[5].text}}</div>
                  <div class="v-data-table__mobile-row__cell">
                    <m-menu left style="float:right" :items="more_menu" :object="item" />
                  </div>
                </div>
              </td>-->
            </tr>
          </template>
        </m-card-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BlockCard from "@/components/BlockCard";
export default {
  components: {
    BlockCard
  },
  data() {
    return {
      menu: false,
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Nama", align: "left", value: "nama" },
        { text: "Surel", align: "left", value: "email" },
        { text: "No HP", align: "left", value: "no_hp" },
        { text: "Gender", align: "left", value: "gender" },
        { text: "Status", sortable: false }
      ],
      more_menu: [
        { divider: true },
        {
          title: "Ubah",
          click: (i, o) => this.edit(o)
        },
        {
          title: "Hapus",
          click: (i, o) => this.delete(o)
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("user/getTenant", { page: this.cp, keyword: this.textSearch })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    setUser(item, obj) {
      this.$confirmDanger(
        `Apakah anda yakin akan mengubah role sebagai User?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${obj.nama}
        </div>
        `
      )
        .then(() =>
          this.$store.dispatch("user/gantiRole", {
            user_id: obj.user_id,
            role: "user"
          })
        )
        .then(() => this.load())
        .catch(e => e);
    },
    hapus(item) {
      this.$confirmDanger(
        
      `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">
          
            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>
            
          <div class="col m11">
          Anda juga akan menghapus seluruh data Organisasi pada Tenant ini.
          Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>
        
        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
        
      `
      )
        .then(() => this.$store.dispatch("operator/drop", item.no_reg))
        .then(() => {
          this.$info("Data operator berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
